export default function Footer(){

    return(
        <div className="footer" style={{textAlign:'center', backgroundColor:'#6E320A', padding:'2rem', margin:'0px', borderTop:'1px solid #6E320A', color: '#e4b04a'}}>
            <p>Codex Sanctus</p>
            <p>Project Built and Maintained by <b>Ahmed SQALLI HOUSSAINI</b></p>
      </div>
    )
};